import { defineMessages, MessageDescriptor } from 'react-intl';
import type { ReleaseThemeId } from 'fym-shared/src/music24/releaseThemes';

/**
 * The name and the one-line feeling of each release theme (design q1, q2). The UI name of `dark`
 * is "Noir": "Theme: Dark" reads as the dark mode of the app. Never show the English label of
 * `RELEASE_THEMES`.
 */
const messages = defineMessages({
  cleanName: { id: 'app.sml.releases.theme.clean.name', defaultMessage: 'Clean' },
  cleanLine: { id: 'app.sml.releases.theme.clean.line', defaultMessage: 'Calm and clear. The cover leads.' },
  hypeName: { id: 'app.sml.releases.theme.hype.name', defaultMessage: 'Hype' },
  hypeLine: { id: 'app.sml.releases.theme.hype.line', defaultMessage: 'Loud and fast. Big words on the beat.' },
  dreamyName: { id: 'app.sml.releases.theme.dreamy.name', defaultMessage: 'Dreamy' },
  dreamyLine: { id: 'app.sml.releases.theme.dreamy.line', defaultMessage: 'Soft and slow. Light and haze.' },
  darkName: { id: 'app.sml.releases.theme.dark.name', defaultMessage: 'Noir' },
  darkLine: { id: 'app.sml.releases.theme.dark.line', defaultMessage: 'Dark and quiet. Like a film.' },
  warmName: { id: 'app.sml.releases.theme.warm.name', defaultMessage: 'Warm' },
  warmLine: { id: 'app.sml.releases.theme.warm.line', defaultMessage: 'Close and golden. Late sun.' },
  retroName: { id: 'app.sml.releases.theme.retro.name', defaultMessage: 'Retro' },
  retroLine: { id: 'app.sml.releases.theme.retro.line', defaultMessage: 'Faded and grainy. An old record sleeve.' },
  neonName: { id: 'app.sml.releases.theme.neon.name', defaultMessage: 'Neon' },
  neonLine: { id: 'app.sml.releases.theme.neon.line', defaultMessage: 'Night lights. Glow on black.' },
  handmadeName: { id: 'app.sml.releases.theme.handmade.name', defaultMessage: 'Handmade' },
  handmadeLine: { id: 'app.sml.releases.theme.handmade.line', defaultMessage: 'Paper, tape and handwriting.' },
});

export interface ReleaseThemeMessages {
  name: MessageDescriptor;
  line: MessageDescriptor;
}

export const releaseThemeMessages: Record<ReleaseThemeId, ReleaseThemeMessages> = {
  clean: { name: messages.cleanName, line: messages.cleanLine },
  hype: { name: messages.hypeName, line: messages.hypeLine },
  dreamy: { name: messages.dreamyName, line: messages.dreamyLine },
  dark: { name: messages.darkName, line: messages.darkLine },
  warm: { name: messages.warmName, line: messages.warmLine },
  retro: { name: messages.retroName, line: messages.retroLine },
  neon: { name: messages.neonName, line: messages.neonLine },
  handmade: { name: messages.handmadeName, line: messages.handmadeLine },
};
